import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import labels from "utils/LocalizedStrings";
import sanitize from "utils/SanitizeHtml";
import { DashboardContext } from "./Dashboard";

const Banner = () => {
  const { participantDetails, investmentDetails } =
    useContext(DashboardContext);
  const [visible, setVisible] = useState(false);
  const [state, setState] = useState({});

  const handleClose = () => {
    setVisible(false);
  };

  const getThirdMessage = (state) => {
    const [before, after] = state.thirdMessage.split("{{link}}");
    return (
      <div>
        <span dangerouslySetInnerHTML={sanitize(before)}></span>
        {state?.label && <Link to={state.path}>{state.label}</Link>}
        {after}
      </div>
    );
  };

  useEffect(() => {
    if (investmentDetails?.asOfBalanceDate) {
      let stateObj = {};
      const today = dayjs();
      const currentYear = today.year();
      const dob = participantDetails.dob;
      const pptDob = dayjs(dob, "MM/DD/YYYY", true);
      let birthdayThisYear = pptDob.year(currentYear);
      if (birthdayThisYear.isBefore(today, "day")) {
        birthdayThisYear = birthdayThisYear.add(1, "year");
      }
      const diffDays = birthdayThisYear.diff(today, "day");
      const sixtyFifth = pptDob.add(65, "year");

      const daysTo65Birthday = Math.max(
        0,
        sixtyFifth.startOf("day").diff(today.startOf("day"), "day")
      );

      // Accumulation Phase
      if (participantDetails.phaseCode === "A") {
        // 1st Condition
        if (daysTo65Birthday >= 46) {
          stateObj = {
            color: "purple",
            firstMessage: labels?.dashboard?.welcome?.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
            secondMessage: "",
            thirdMessage: labels?.dashboard?.learnAboutInvestment,
            label: labels?.navbar?.insights,
            path: "/learning-center",
          };
        }
        // 2nd Condition
        if (daysTo65Birthday <= 45 && !investmentDetails?.stepUpCompleted) {
          stateObj = {
            color: "purple",
            firstMessage: labels?.dashboard?.welcome?.replace(
              "~participantName~",
              participantDetails?.firstName,
            ),
            secondMessage: "",
            thirdMessage: investmentDetails?.fundLevelBalance?.some(
              (e) => e.fundType === "T",
            )
              ? labels?.dashboard?.atAge65Message
              : labels?.dashboard?.atAge65MessageForBalancedFund,
          };
        }
        // 3rd Condition
        if (
          daysTo65Birthday <= 0 &&
          investmentDetails?.stepUpCompleted &&
          investmentDetails?.accountBalance
        ) {
          stateObj = {
            color: "green",
            firstMessage: labels?.dashboard?.congratulations?.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
            secondMessage: labels?.dashboard?.eligibleToMakeElection,
            thirdMessage: labels?.dashboard?.incomeElectionMessage,
            label: labels?.dashboard?.incomeElection,
            path: "/income-election/1",
          };
        }
        if (!stateObj.color) {
          stateObj = {
            color: "purple",
            firstMessage: `${labels?.dashboard?.welcomeBackWithoutName} ${participantDetails?.firstName}!`,
          };
        }
        setState(stateObj);
      }

      // Withdrawal Phase
      else {
        // 1st Condition
        if (diffDays <= 45) {
          stateObj = {
            color: "green",
            firstMessage: labels?.dashboard?.welcomeBack.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
            secondMessage: "",
            thirdMessage: labels?.dashboard?.incomeBaseResetMsg,
          };
        }

        // 3rd Condition
        if (investmentDetails?.monthlyPayoutsInfo?.moneyOutApiReject) {
          stateObj = {
            color: "red",
            firstMessage: labels?.dashboard?.welcomeBack.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
            secondMessage: "",
            thirdMessage: labels?.dashboard?.monthlyInstallmentPayoutNotMade,
          };
        }

        // 2nd Condition
        if (investmentDetails?.monthlyPayoutsInfo?.excessWdlAmount > 0) {
          stateObj = {
            color: "red",
            firstMessage: labels?.dashboard?.welcomeBack.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
            secondMessage: labels?.dashboard?.reviewYourPayout,
            thirdMessage: labels?.dashboard?.excessWithdrawalMsg,
          };
        }

        // 4th Condition
        if (
          investmentDetails?.monthlyPayoutsInfo?.payoutStatusCode === "S" ||
          !investmentDetails?.monthlyPayoutsInfo
        ) {
          stateObj = {
            color: "purple",
            firstMessage: labels?.dashboard?.welcomeBack.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
            secondMessage:
              labels?.dashboard?.monthlyPayoutElectionEligibilityMsg,
            thirdMessage: labels?.dashboard?.monthlyPayoutElectionMessage,
            label: labels?.dashboard?.monthlyPayoutElection,
            path: "/monthly-payout-election/1",
          };
        }
        if (!stateObj?.color) {
          stateObj = {
            color: "purple",
            firstMessage: labels?.dashboard?.welcomeBack.replace(
              "~participantName~",
              participantDetails?.firstName
            ),
          };
        }

        setState(stateObj);
      }
    }
  }, [investmentDetails]);

  useEffect(() => {
    if (state?.color) {
      setVisible(true);
    }
  }, [state]);

  if (visible) {
    return (
      <section
        className={`dashboard-layout shadow-lg row py-5 banner ${state.color}`}
      >
        <div className="close-button" onClick={handleClose}>
          X
        </div>
        {state?.firstMessage && (
          <div
            className="h3 mb-2"
            dangerouslySetInnerHTML={sanitize(state.firstMessage)}
          />
        )}
        {state.secondMessage && (
          <div className="h5 mb-3">{state.secondMessage}</div>
        )}
        {state?.thirdMessage && getThirdMessage(state)}
      </section>
    );
  }
};

export default Banner;
